// extracted by mini-css-extract-plugin
module.exports = {"root":"SdtRA","foreground":"_3OgZ_","titleContainer":"_1-PuE","parentLink":"_2-w8T","content":"_3A6dr","eldritchRune":"Wicpj","spin":"_2Eqvn","runeContainer":"_3ZeTh"};